/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_ACTION = '/rewards';

/**
 * applyTalonRewards
 * url - /checkout/{apiversion}/cart/{cartId}/rewards
 *
 * @param {Object} args
 * @param {Object} args.env
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 * @param {String} args.programName
 * @param {String} args.campaignId
 * @param {String} args.bannerCode
 */
const applyTalonRewards = ({
    env,
    jwtToken,
    cartId,
    programName,
    campaignId,
    bannerCode,
}) => {
    const envObj = {
        ...(env || {}),
        rootUri: `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`,
    };

    const payload = {
        programName,
        campaignId,
        bannerCode,
    };

    const resourcePage = `${RESOURCE_PAGE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_ACTION}`;

    return restClient.postRequest(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default applyTalonRewards;
